'use client';

import { c as _c } from "react/compiler-runtime";
import React, { Children, isValidElement, type ReactNode } from 'react';
import { cn } from '../../../shared/cn';
export function InputGroup(t0) {
  const $ = _c(13);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  let t2;
  if ($[4] !== children || $[5] !== className) {
    const hasDisabledChild = Children.toArray(children).some(_temp);
    t1 = hasDisabledChild ? "true" : undefined;
    t2 = cn("relative isolate block", "has-[[data-slot=icon]:last-child]:[&_input]:pr-10 has-[[data-slot=icon]:first-child]:[&_input]:pl-10 sm:has-[[data-slot=icon]:last-child]:[&_input]:pr-8 sm:has-[[data-slot=icon]:first-child]:[&_input]:pl-8", "*:data-[slot=icon]:pointer-events-none *:data-[slot=icon]:absolute *:data-[slot=icon]:top-3 *:data-[slot=icon]:z-10 *:data-[slot=icon]:size-5 sm:*:data-[slot=icon]:top-2.5 sm:*:data-[slot=icon]:size-4", "[&>[data-slot=icon]:first-child]:left-3 sm:[&>[data-slot=icon]:first-child]:left-2.5 [&>[data-slot=icon]:last-child]:right-3 sm:[&>[data-slot=icon]:last-child]:right-2.5", "*:data-[slot=icon]:text-contentTertiary", hasDisabledChild && "*:data-[slot=icon]:text-contentTertiary/50", className);
    $[4] = children;
    $[5] = className;
    $[6] = t1;
    $[7] = t2;
  } else {
    t1 = $[6];
    t2 = $[7];
  }
  let t3;
  if ($[8] !== children || $[9] !== props || $[10] !== t1 || $[11] !== t2) {
    t3 = <span data-disabled={t1} className={t2} {...props}>{children}</span>;
    $[8] = children;
    $[9] = props;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
}
function _temp(child) {
  return isValidElement(child) && (child.props as {
    disabled?: boolean;
  })?.disabled;
}